module.exports = __webpack_public_path__ + "static/media/snow3.793b42b9.webm";